var _g, _circle, _path, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgAddBucket(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 94,
    height: 91,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#addBucket_svg__filter0_f)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 47,
    cy: 47,
    r: 37,
    fill: "#fff"
  }))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 47,
    cy: 47,
    r: 28,
    fill: "#EBD18A"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M55.5 48.417h-7.083V55.5A1.42 1.42 0 0147 56.917a1.42 1.42 0 01-1.417-1.417v-7.083H38.5A1.42 1.42 0 0137.083 47c0-.78.638-1.417 1.417-1.417h7.083V38.5c0-.78.638-1.417 1.417-1.417.78 0 1.417.638 1.417 1.417v7.083H55.5c.78 0 1.417.638 1.417 1.417a1.42 1.42 0 01-1.417 1.417z",
    fill: "#404357"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "addBucket_svg__filter0_f",
    x: 0,
    y: 0,
    width: 94,
    height: 94,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5,
    result: "effect1_foregroundBlur"
  })))));
}

export default SvgAddBucket;